export default {
    methods: {
        isErrorCell(status) {
            /**
             * Граммотней было бы сделать зависимость другого рода,
             * но если текст не будет меняться, тогда ок
             */
            const { name, name___ru } = status;
            const errorMessage = 'Ошибка';
            return name === errorMessage || name___ru === errorMessage;
        }
    }
};
